// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bhv_a bik_h","Menu__offsetParent":"bhv_b bik_bj","Menu__trigger--shadowed":"bhv_c"};